import React from 'react'
import styled, { css } from 'react-emotion'
import { color, spacer } from 'stylist'

const SummaryDuration = styled.div`
  width: 100%;
  background-color: ${color('paleGrey')};
  position: relative;
  height: ${spacer(2)};
`

const dynamicWidth = props => css`
  width: ${props.width};
  left: ${props.left};
`

const SummaryBar = styled.div`
  background-color: ${color('brandGreen')};
  height: 100%;
  position: absolute;
  ${dynamicWidth};
  min-width: 1px;
`
const percentAtTime = (time, duration) => (time * 100) / duration + '%'
const clipDuration = (clip, duration) =>
  percentAtTime(clip.endTime - clip.startTime, duration)

const ClipDurationBar = ({ clip, duration }) => (
  <SummaryDuration>
    <SummaryBar
      width={clipDuration(clip, duration)}
      left={percentAtTime(clip.startTime, duration)}
    />
  </SummaryDuration>
)

ClipDurationBar.defaultProps = {
  duration: 0,
  clip: { startTime: 0, endTime: 0 }
}

export default ClipDurationBar



// WEBPACK FOOTER //
// ./src/routes/video/components/ClipDurationBar.js